import { StyledAnchor, StyledImage } from './Logo.styles';
import qn from './qn.svg';
import ilresto from './ilrestodelcarlino.svg';
import ilgiorno from './ilgiorno.svg';
import iltelegrafo from './iltelegrafo.svg';
import lanazione from './lanazione.svg';

import { TESTATE } from '../../lib/constants';
import { getTestata } from '../../lib/utils';

const testata = getTestata();
const LOGOS = {
  qn,
  ilresto,
  ilgiorno,
  iltelegrafo,
  lanazione,
};

function Logo() {
  return (
    <StyledAnchor href="/">
      <StyledImage src={LOGOS[testata]} alt={TESTATE[testata].title} />
    </StyledAnchor>
  );
}

export default Logo;
